import React from 'react'

import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import type { HeaderColumn } from '@/components/_headers/headerData'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/_ui/Accordion'
import useGlobalStore from '@/store/useGlobalStore'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'

type Props = {
  columns: [HeaderColumn, HeaderColumn?, HeaderColumn?]
}

export const MobileMenuColumns = ({ columns }: Props) => {
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()
  const { setApp } = useGlobalStore()
  const { gtm } = useGTM()

  return (
    <Accordion type="single" collapsible>
      {columns.map((column, index) => {
        if (!(column?.title && column.title.length > 0)) {
          return null
        }

        return (
          <AccordionItem
            key={column?.title}
            value={column?.title || `${index}`}
          >
            <AccordionTrigger>{column?.title}</AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col space-y-3 border-l pl-5">
                {column?.items?.map((item) => (
                  <a
                    onClick={() => {
                      gtm.navbarMenuItemClicked({
                        action: item.title,
                        category: column.title,
                      })

                      mixpanelService
                        .trackEvent(
                          MixpanelEvent.NAVIGATION_BAR_SHOP_MENU_ITEM_CLICKED,
                          {
                            action:
                              (item.href.at(-1) === '/'
                                ? item.href.split('/').at(-2)
                                : item.href.split('/').at(-1)) || '',
                            category: column.title,
                          },
                        )
                        .catch(() => {})

                      setApp({ isMobileDrawerOpen: false })
                    }}
                    className="text-primary no-underline hover:underline"
                    key={item.title}
                    href={parseLinkUrlWithLocale({ url: item.href })}
                  >
                    {item.title}
                  </a>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}
